import { Link, Navigate, Route, Routes, useLocation, useNavigate, useParams } from "react-router";


import { useEffect, useState } from "react";
import * as projectsClient from "./projectsClient";
import { LuLogOut } from "react-icons/lu";
import { FaAngleDoubleDown } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { IoDocumentOutline } from "react-icons/io5";
import { GoVideo } from "react-icons/go";
export default function Projects() {
    const navigate = useNavigate()
    const [projects, setProjects] = useState<any[]>([])
    const {pid} = useParams()

    const [showModal, setShowModal] = useState(false);
    const [currentPdf, setCurrentPdf] = useState<string | null>(null);

    const [showVideoModal, setShowVideoModal] = useState(false);
    const [currentVideo, setCurrentVideo] = useState<string | null>(null);


    const openVideoModal = (videoUrl: string) => {
        setCurrentVideo(videoUrl);
        setShowVideoModal(true);
    };

    const closeVideoModal = () => {
        setShowVideoModal(false);
        setCurrentVideo(null);
    };

    const openModal = (pdfUrl: string) => {
        setCurrentPdf(pdfUrl);
        setShowModal(true);
      };
      
      const closeModal = () => {
        setShowModal(false);
        setCurrentPdf(null);
      };
      
    const project = projects.find((p:any)=> p._id==pid)

    const fetchAllProjects = async () => {
        try {
        const projects = await projectsClient.fetchAllProjects(); 
        setProjects(projects)
        } catch (error) {
        console.error(error);
        }
    };
    const isMobile = window.innerWidth < 1024;

    
    const [loading, setLoading] = useState(false)
    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        await Promise.all([fetchAllProjects()]);
        setLoading(false);
      };
      fetchData();
    }, []);
  
    if (loading) {
      return <div>Loading...</div>; 
    }
    
    return (
        <>       

         <h1 className="mt-4 ms-3">{project && project.name} <button id="learn-more-projects-button" className="btn text-nowrap float-end me-5" style={{background:"rgb(13, 159, 125)", color:"white"}} onClick={() => {document.querySelector(".projects-info")?.scrollIntoView({ behavior: "smooth" });}}>Learn more <FaAngleDoubleDown /></button></h1>

            <hr />
         <div style={{display:"flex"}} className="mb-5">

        {project && project.video &&
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "auto" }}>
        
            <video
                src={project.video}
                controls
                style={{width: "80%", height: "auto", borderRadius: "10px" }}
            >
                Your browser does not support the video tag.
            </video>
        </div>
        }

    </div>




    {project && project.info_string && project.info_string.remark &&
            <div className="p-4">
         <p className="text-danger border rounded-5 p-4 bg-warning bg-opacity-10"><span style={{color:"red", fontWeight:"bold"}}>Remark: </span>{project.info_string.remark}</p>
         </div>}

         <div className="p-4">

        <div className="border d-flex flex-wrap rounded-5">
            <div className="flex-grow-1">
                <h4 style={{textAlign: "center" }} className="mb-5">Related Images</h4>
                    <div className="p-2 ms-5" style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                        {project && project.info_pic && project.info_pic.map((pic: any, index: number) => (
                            <div key={index} style={{ flex: "1 1 calc(50% - 10px)", marginBottom: "10px" }}>
                                <img src={pic} alt="" style={{ width: "100%" }} />
                            </div>
                        ))}
                    </div>
            </div>

            <div className="project-skills flex-grow-1">
                    <h4 className="mt-5" style={{textAlign: "center" }}>Skills & Knowledge Acquired</h4>
                    {project && project.skills && project.skills.map((s:any)=>(
                        <ul className="list-group" style={{width:"100%", textAlign: "center",justifyContent: "center"}}>
                            <li className="list-group-item border-0 border-top border-start border-end list-group-item-action" >{s}</li>
                        </ul>
                    ))}
            </div>
            </div>
            </div>

       



            <div className="projects-info p-5">
            
            
            <h4 style={{color:"white", textAlign:"center"}} className="mb-5">Supporting Documents</h4>

            <div className="project-docs">
                {project && project.info_string && 
                <>
                {project.info_string.report ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}} onClick={() => openModal(project.info_string.report)}>Final Report <IoDocumentOutline className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                {project.info_string.design ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}} onClick={() => openModal(project.info_string.design)}>Conceptual Design <IoDocumentOutline className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                {project.info_string.srs ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}} onClick={() => openModal(project.info_string.srs)}>Software Requirements Specifications <IoDocumentOutline className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                {project.info_string.sdd ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}} onClick={() => openModal(project.info_string.sdd)}>Software Design Description <IoDocumentOutline className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                </>  
                }
                
                    {showModal && currentPdf && (
                        <div className="modal show" style={{ display: 'block' }} onClick={closeModal}>
                        <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Report - {project.name}</h5>
                                <button className="btn-close" onClick={closeModal}>
                                <IoMdClose className='mb-3'/>
                                </button>
                            </div>
                            <div className="modal-body">
                            {isMobile ? (
                                <div>
                                <p>Viewing the PDF on mobile or tablet may be limited. Please open it in fullscreen:</p>
                                <a
                                    href={currentPdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                >
                                    Open PDF
                                </a>
                                </div>
                            ) : (
                                <iframe
                                src={currentPdf}
                                width="100%"
                                height="500px"
                                title="Research Paper"
                                />
                            )}
                            </div>
                            </div>
                        </div>
                        </div>
                    )}
            {project && project.info_video && 
                <>
                {project.info_video.demo1 ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}} onClick={() => openVideoModal(project.info_video.demo1)}>ML Demo <GoVideo className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                {project.info_video.demo2 ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}}  onClick={() => openVideoModal(project.info_video.demo2)}>Anti-Spoofing Demo <GoVideo className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                {project.info_video.kanbas1 ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}}  onClick={() => openVideoModal(project.info_video.kanbas1)}>Admin<GoVideo className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                {project.info_video.kanbas2 ? <><button className="btn mb-3" style={{width:"auto",background:"rgb(13, 159, 125)", color:"white"}}  onClick={() => openVideoModal(project.info_video.kanbas2)}>Student & Faculty<GoVideo className="mb-1 ms-2 fs-5"/></button><br /></> : null}
                </>  
                }
                {showVideoModal && currentVideo && (
                    <div className="modal show" style={{ display: "block" }} onClick={closeVideoModal}>
                        <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Video Demo</h5>
                                    <button className="btn-close" onClick={closeVideoModal}><IoMdClose className="mb-3"/></button>
                                    
                                </div>
                                <div className="modal-body">
                                    <video
                                        src={currentVideo}
                                        controls
                                        style={{ width: "100%", borderRadius: "10px" }}
                                        autoPlay
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <br /><br />

            </div>
            </div>


    </>

    );
}